<p>Zdalne logowanie</p>
<button mat-button (click)="remoteLogin()">Zaloguj się na konto</button>

<a *ngIf="loginUrl" [href]="loginUrl" target="_blank">Link do logowania</a>
